<template>
  <div class="dashboard body">
    <el-container>
      <!-- <ProductsAside /> -->
      <el-main>
        <el-row class="table mt-2 px-3">
          <div
            class="
              el-table
              el-table--fit
              el-table--border
              el-table--scrollable-y
              el-table--enable-row-hover
              el-table--enable-row-transition
            "
            style="margin-top: 20px; height: 77vh"
          >
            <div class="el-table__header-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__header"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="5%" />
                  <col name="el-table_3_column_12" width="33%" />
                  <col name="el-table_3_column_13" width="13%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="7%" />
                  <col name="el-table_3_column_17" width="7%" />
                  <col name="el-table_3_column_18" width="9%" />
                  <col name="el-table_3_column_19" width="5%" />
                </colgroup>
                <thead class="has-gutter">
                  <tr class="">
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">#</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">المنتج</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">الوحدة</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">الكمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">سعر البيع</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">أخر سعر</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell center">الإجمالي</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">المتاح</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <div class="cell"></div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <!-- id="scrollToMe" -->
            <div
              class="el-table__body-wrapper"
              style="height: auto; max-height: 44vh"
              ref="products_table"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__body"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="5%" />
                  <col name="el-table_3_column_12" width="33%" />
                  <col name="el-table_3_column_13" width="13%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="7%" />
                  <col name="el-table_3_column_17" width="7%" />
                  <col name="el-table_3_column_18" width="9%" />
                  <col name="el-table_3_column_19" width="5%" />
                </colgroup>
                <!-- id="order" -->
                <tbody class="bodytable">
                  <tr
                    class="el-table__row"
                    v-for="(item, index) in sales[selectedIndex].products"
                    :key="index"
                  >
                    <!-- :class="[
                      item.sale_price < 5 || item.qty < 5 ? 'bg-Red' : '',
                    ]" -->
                    <td rowspan="1" colspan="1" class="el-table_3_column_11">
                      <div class="cell num">{{ index + 1 }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_12">
                      <div class="cell">{{ item.name }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_13">
                      <div class="cell">
                        {{ item.unit.unit }}
                        <!-- <el-select
                          v-model="form.selected"
                          placeholder="حدد الوحدة"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select> -->
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_14">
                      <div class="cell">
                        <!-- New -->
                        <!-- readonly -->
                        <input
                          @blur="updateProductQty(item, index)"
                          class="form-control"
                          type="number"
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.qty"
                          placeholder="الكمية"
                          min="0"
                        />
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_15">
                      <div class="cell">
                        <input
                          class="form-control"
                          type="number"
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.sale_price"
                          placeholder=" البيع"
                          min="0"
                        />
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_16">
                      <div class="cell center">
                        {{ numberToFixed(item.lastSaleCost) }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_17">
                      <div class="cell center">
                        {{ numberToFixed(item.sale_price * item.qty) }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_18">
                      <div class="cell center">
                        {{ numberToFixed(item.stock) }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_19">
                      <div class="cell">
                        <el-popconfirm
                          confirm-button-text="موافق"
                          cancel-button-text="إلغاء"
                          icon="el-icon-info"
                          icon-color="red"
                          :title="'هل تريد حذف ' + ' ' + item.name + ' ؟'"
                          @confirm="deleteItem(item, index)"
                        >
                          <div slot="reference" class="deleteicon">
                            <i class="fas fa-trash-alt"></i>
                          </div>
                        </el-popconfirm>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a id="goToBottom" href="#scrollToMe"></a>
              <div id="scrollToMe"></div>
            </div>
            <div
              class="el-table__footer-wrapper"
              v-if="sales[selectedIndex].supplier"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__footer"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="5%" />
                  <col name="el-table_3_column_12" width="33%" />
                  <col name="el-table_3_column_13" width="13%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="7%" />
                  <col name="el-table_3_column_17" width="7%" />
                  <col name="el-table_3_column_18" width="9%" />
                  <col name="el-table_3_column_19" width="5%" />
                </colgroup>
                <tbody class="has-gutter footer">
                  <tr>
                    <!-- <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell num">{{ ind + 1 }}</div>
                    </td> -->
                    <td
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">
                        <!-- value-key="name" -->
                        <div class="searchInput">
                          <SearchProducts
                            :showStockZero="false"
                            ref="searchProductsComponent"
                            :supplier="supplier"
                            @selectedProduct="selectedProduct"
                          />
                        </div>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">
                        <el-select
                        id="unit"
                        @input="productUnitSelected()"
                          v-model="selectedUnitId"
                          placeholder="حدد الوحدة"
                        >
                          <el-option
                            v-for="unit in productUnits"
                            :key="unit.id"
                            :label="unit.unit"
                            :value="unit.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">
                        <!-- New -->

                        <vs-tooltip
                          top
                          shadow
                          not-hover
                          v-model="showQtyToolTip"
                        >
                          <input
                            :class="showQtyToolTip ? 'error' : ''"
                            class="form-control qty"
                            type="number"
                            @focus="$event.target.select()"
                            v-model="qty"
                            placeholder=" الكمية"
                            min="0"
                            @change="validateQty"
                            @keyup.enter="validateQty"
                          />
                          <template #tooltip>
                            <div class="content-tooltip">الكمية غير صحيحة</div>
                          </template>
                        </vs-tooltip>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">
                        <vs-tooltip
                          top
                          shadow
                          not-hover
                          v-model="showPriceToolTip"
                        >
                          <input
                            type="number"
                            @change="validatePrice"
                            @keyup.enter="addNewItem"
                            :class="showPriceToolTip ? 'error' : ''"
                            v-model="sale_price"
                            @focus="$event.target.select()"
                            class="form-control sale_price"
                            placeholder=" البيع"
                            min="0"
                          />
                          <template #tooltip>
                            <div class="content-tooltip">
                              سعر البيع اقل من سعر الشراء
                            </div>
                          </template>
                        </vs-tooltip>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">
                        {{ selectedProductlastSaleCost }}
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell center" v-if="qty * sale_price > 0">
                        {{ numberToFixed(qty * sale_price) }}
                      </div>
                      <div class="cell center" v-else>-</div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">
                        <b> {{ selectedProductStockLabel }}</b>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <div class="cell center">
                        <el-button
                          v-if="product"
                          type="success"
                          @click="addNewItem"
                          title="إضافة المنتج"
                        >
                          <i class="fas fa-plus"></i>
                        </el-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-row>
        <el-row :gutter="10" class="footer">
          <el-col :xl="4" :lg="4" :md="18" :sm="24">
            <div
              class="bg-White alignment p-3 mt-2"
              v-if="sales[selectedIndex].products.length > 0"
            >
              <p>
                الكميه
                <span class="num">{{ sales[selectedIndex].total_qty }}</span>
              </p>
            </div>
          </el-col>
          <el-col :xl="12" :lg="12" :md="6" :sm="24"
            ><div class="bg-White alignment mt-2">
              <!-- :disabled="disabled" -->
              <el-button
                v-if="sales[selectedIndex].products.length > 0"
                class="save"
                :loading="isLoading"
                @click="showPaymentModal"
                >حفظ المنتجات توالف</el-button
              >

              <span
                :class="[
                  sales[selectedIndex].products.length > 0 ? '' : 'mr-auto',
                ]"
                class="pl-3"
              >
                <el-popconfirm
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  title="هل تريد مسح الفاتورة؟"
                  @confirm="resetInvoiceData"
                >
                  <div slot="reference">
                    <el-button class="exit mr-3">مسح المنتجات</el-button>
                  </div>
                </el-popconfirm></span
              >
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <div v-if="confirmSave == true" class="dialog">
        <div class="bodySec">
          <p @click="confirmSave = false">
            <span><i class="far fa-times-circle"></i></span> اغلاق
          </p>
        </div>
        <div class="content">
          <div class="headerSection mt-2">
            <p>هل تريد تاكيد الحفظ؟</p>
          </div>
          <el-button class="mt-3 btn-green1" type="success" @click="addSale"
            >حفظ</el-button
          >
          <el-button
            type="danger"
            @click="confirmSave = false"
            class="exit mr-3"
            >الغاء</el-button
          >
        </div>
        <br />
      </div>
  </div>
</template>

<script>
// import ProductsAside from "@/components/ProductsAside.vue";
import SearchProducts from "@/components/Products/SearchWithLastBuyPrice";
import axiosApi from "@/plugins/axios.js";
export default {
  components: {  SearchProducts },
  name: "DamagedProducts",
  data: () => ({
    true: true,
    loadingStart: true,
    invoice_details: null,
    disabled: false,
    isLoading: false,
    false: false,
    supplier: {
      id: 1,
      name: "wahtever",
      balance: 0,
    },
    product: null,
    selectedUnitId: null,
    productUnits: [],
    selectedUnit: null,
    sale_price: "",
    min_price: "",
    qty: 1,
    active: "DamagedProducts",
    confirmSave: false,
    timeout: null,
    selectedProductlastSaleCost: "-",
    selectedProductStock: 0,
    selectedProductBuyCost: 0,
    selectedProductStockLabel: "-",
    value: "",
    num: 1,
    ind: 0,
    selectedPorductIndex: 0,
    setPaied: "without",
    activeDelete: false,
    showPriceToolTip: false,
    showQtyToolTip: false,
    selectedIndex: 0,
    showPrice: false,
    activeSide: true,
    useParcode: false,
    autoPush: true,
    sales: [
      {
        inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0].id,
        paied: 0,
        VAT: 0,
        supplier: {
          id: 1,
          name: "wahtever",
          balance: 0,
        },
        total_cost: 0,
        total_buy_cost: 0,
        total_sale_cost: 0,
        total_qty: 0,
        total_discount: 0,
        percentage_discount: 0,
        products: [],
      },
    ],
  }),
  watch: {
    setPaied: function () {
      this.sales[this.selectedIndex].paied = 0;
      setTimeout(() => {
        document.getElementById("paied").focus();
      }, 100);
    },

    selectedIndex: function (newValue, oldValue) {
      if (newValue != oldValue) {
        if (this.sales[newValue].supplier != null) {
          this.supplier = this.sales[newValue].supplier;
        }
        this.checkOrderStock();
      }
    },
  },
  created() {
    if (localStorage.getItem("DamagedList")) {
      let sale_data = localStorage.getItem("DamagedList");
      this.sales = JSON.parse(sale_data);
      this.supplier = {
      id: 1,
      name: "wahtever",
      balance: 0,
    },
      this.calcTotal();
    }
    this.checkOrderStock();
  },
  mounted() {
    this.scrollToEnd();
    console.log(this.$refs.searchProductsWithBarcode);
  },
  methods: {
    checkOrderStock() {
      if (this.sales[this.selectedIndex].products.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل الفاتورة",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axiosApi
          .post(`receipt/check-stock`, {
            products: this.sales[this.selectedIndex].products,
          })
          .then((res) => {
            this.sales[this.selectedIndex].products = res.data;
            this.setLocalStorage();
          })
          .catch((e) => {
            console.log(e);
            //   this.$snotify.error("عفوا لا يوجد منتج للباركود المحدد");
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    validateQty() {
      // if(this.qty==0||this.qty==""){
      //   this.qty=1;
      // }

      if (
        this.qty <= this.selectedProductStock &&
        this.qty > 0 &&
        this.qty != ""
      ) {
        this.showQtyToolTip = false;
        setTimeout(()=>{
          this.setPriceFocus();
        },100);
      } else {
        this.showQtyToolTip = true;
      }
    },

    validatePrice() {
      if (this.qty <= this.selectedProductStock) {
        if (this.sale_price > this.selectedProductBuyCost) {
          this.showPriceToolTip = false;
        } else {
          this.showPriceToolTip = true;
        }
      } else {
        this.showQtyToolTip = true;
        document.querySelector(".qty").focus();
      }
    },
    alert() {
      alert("price clicked");
    },

    openPaymentModal() {
      this.$prompt("حدد المبلغ", "تحصيل من العملاء", {
        confirmButtonText: "تحصيل",
        showClose: false,
        showCancelButton: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        inputValue: 0,
        customClass: "float-right",
        inputErrorMessage: "مبلغ غير صحيح",
      })
        .then(({ value }) => {
          if (value >= 0) {
            this.sales[this.selectedIndex].paied = Number(value);
            this.addSale();
          } else {
            this.openPaymentModal();
            this.$notify({
              title: "حدث خطأ",
              message: "عفوا المبلغ غير صحيح ",
              type: "error",
              duration: 1500,
            });
          }
        })
        .catch(() => {
          this.sales[this.selectedIndex].paied = 0;
        });
    },
    discountPreChange() {
      this.sales[this.selectedIndex].total_discount = parseFloat(
        (this.sales[this.selectedIndex].percentage_discount *
          this.sales[this.selectedIndex].total_sale_cost) /
          100
      ).toFixed(2);
      this.setLocalStorage();
    },

    discountChange() {
      this.sales[this.selectedIndex].percentage_discount = (
        parseFloat(
          this.sales[this.selectedIndex].total_discount /
            this.sales[this.selectedIndex].total_sale_cost
        ) * 100
      ).toFixed(2);
      this.setLocalStorage();
    },

    setSelectedInvoice(index) {
      this.selectedIndex = index;
      this.supplier = this.sales[index].supplier;
      this.clearProduct();
    },
    setPriceFocus() {
      if (this.showQtyToolTip == false) {
        document.querySelector(".sale_price").focus();
      }
    },
    selectedProduct(e) {
      if (e.product != null) {
        this.product = e.product;
        this.$refs.searchProductsComponent.setValue(this.product);
        this.productUnits = e.product.prices;
        this.selectedUnitId = e.product.prices[0].id;
        this.selectedUnit = e.product.prices[0];
        this.sale_price = this.selectedUnit.sale_price;
        this.min_price = this.selectedUnit.min_price;
        this.selectedProductBuyCost = e.product.inventories[0].pivot.buy_cost;
        this.selectedProductStock = this.numberToFixed(
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
            this.product.units_per_package
        );
        this.selectedProductStockLabel = this.numberToFixed(
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
            this.product.units_per_package
        );
        if (e.product.mainUnitLastInvoice != null) {
          this.selectedProductlastSaleCost =
            e.product.mainUnitLastInvoice.sale_price;
        } else {
          this.selectedProductlastSaleCost = "-";
        }
        setTimeout(() => {
          document.querySelector("#unit").focus();
        }, 200);
      } else {
        this.clearProduct();
      }
    },
    productUnitSelected(){
      this.selectedUnit=this.productUnits.filter((unit)=>{
        return unit.id ==this.selectedUnitId;
      })[0]
      this.sale_price = this.selectedUnit.sale_price;
      this.min_price = this.selectedUnit.min_price;
      this.selectedProductBuyCost = this.product.inventories[0].pivot.buy_cost;
      this.selectedProductStock = this.numberToFixed(
        (this.product.inventories[0].pivot.qty -
          this.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package
      );
      this.selectedProductStockLabel = this.numberToFixed(
        (this.product.inventories[0].pivot.qty -
          this.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package
      );
      if (this.product.mainUnitLastInvoice != null) {
        this.selectedProductlastSaleCost =
          this.product.mainUnitLastInvoice.sale_price;
      } else {
        this.selectedProductlastSaleCost = "-";
      }
      setTimeout(() => {
        document.querySelector(".qty").focus();
      }, 200);
    },
    selectedProductWithBarcode(e) {
      this.product = e.product;
      if (this.product != null) {
        this.$refs.searchProductsComponent.setValue(this.product);

        this.productUnits = e.product.prices;

        let selectedBarcodeUnit = e.product.prices.filter((item) => {
          return item.code == e.barcode;
        });

          this.selectedUnit = selectedBarcodeUnit[0];
          this.selectedUnitId = selectedBarcodeUnit[0].id;
        this.sale_price = this.selectedUnit.sale_price;
        this.min_price = this.selectedUnit.min_price;
        this.selectedProductBuyCost = e.product.inventories[0].pivot.buy_cost;
        this.selectedProductStock =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        this.selectedProductStockLabel =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        //    +
        // " " +
        // this.productUnits[0].unit;
        if (e.product.unitLastInvoice != null) {
          this.selectedProductlastSaleCost =
            e.product.unitLastInvoice.sale_price;
        } else {
          this.selectedProductlastSaleCost = "-";
        }

          if(this.useParcode && this.autoPush){
            this.addNewItem();
            // document.querySelector(".parcodeSearch input[type='text']").value = '';

          }else{

            setTimeout(() => {
              document.querySelector(".qty").focus();
            }, 200);
          }

      } else {
        this.clearProduct();

      }
    },
    showPaymentModal() {
      this.confirmSave = true;
    },
    addNewItem() {
      if (this.loadingStart) {
        if (this.qty > 0 && !this.showQtyToolTip && !this.showPriceToolTip) {
          if (this.product && this.product.inventories.length == 0) {
            this.$snotify.error(` ${this.product.name} عفوا لا يوجد مخزون من `);
          } else {
            let barcode = this.selectedUnit.code;
            let unit_type = this.selectedUnit.type;
            let products = [];
            // ! check qty to hold
            let selectedProduct = {
              id: this.product.id,
              qty: this.qty,
              unit_type: unit_type,
              inventory_id: JSON.parse(
                localStorage.getItem("user_inventories")
              )[0].id,
              units_per_package: this.product.units_per_package,
            };
            products.push(selectedProduct);
            const loading = this.$loading({
              lock: true,
              text: "جاري تحميل الفاتورة",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            this.loadingStart = false;
            axiosApi
              .post(`products/hold`, { products: products })
              .then((res) => {
                loading.close();
                let available_qty = res.data.qty;
                if (unit_type == 1) {
                  available_qty = res.data.qty / this.product.units_per_package;
                }

                var product = this.sales[this.selectedIndex].products.filter(
                  function (elem) {
                    if (elem.barcode == barcode) return elem;
                  }
                );

                if (product.length > 0) {
                  this.sales[this.selectedIndex].products.splice(
                    this.sales[this.selectedIndex].products.findIndex(
                      (e) => e.barcode == barcode
                    ),
                    1
                  );

                  // if (available_qty >= this.qty) {
                  this.sales[this.selectedIndex].products.push({
                    id: product[0].id,
                    name: product[0].name,
                    barcode: product[0].barcode,
                    units_per_package: product[0].units_per_package,
                    unit: product[0].unit,
                    units: product[0].units,
                    unit_type: product[0].unit_type,
                    sale_price: product[0].sale_price,
                    min_price: product[0].min_price,
                    buy_cost: Number(product[0].buy_cost),
                    stock: available_qty,
                    lastSaleCost: product[0].lastSaleCost,
                    old_qty: Number(product[0].qty) + Number(this.qty),
                    qty: Number(product[0].qty) + Number(this.qty),
                    showQtyToolTip: false, //new code
                    showPriceToolTip: false, //new code
                    inventory_id: JSON.parse(
                      localStorage.getItem("user_inventories")
                    )[0].id,
                  });

                  this.clearProduct();
                  this.calcTotal();
                  this.setLocalStorage();
                } else {
                  let buy_cost = 0;
                  let lastSaleCost = "";
                  if (this.selectedUnit.type == 1) {
                    if (this.product.mainUnitLastInvoice != null) {
                      lastSaleCost =
                        this.product.mainUnitLastInvoice.sale_price;
                    }
                  } else if (this.selectedUnit.type == 2) {
                    if (this.product.secondUnitLastInvoice != null) {
                      lastSaleCost =
                        this.product.secondUnitLastInvoice.sale_price;
                    }
                  } else {
                    lastSaleCost = "";
                  }
                  if (this.product.inventories.length > 0) {
                    if (this.selectedUnit.type == 1) {
                      buy_cost = this.product.inventories[0].pivot.buy_cost;

                      // stock = Number(
                      //   available_qty / this.product.units_per_package
                      // );
                    } else {
                      buy_cost =
                        this.product.inventories[0].pivot.buy_cost /
                        this.product.units_per_package;
                      // stock = available_qty;
                    }
                  }

                  // if (stock >= this.qty) {
                  this.sales[this.selectedIndex].products.push({
                    id: this.product.id,
                    name: this.product.name,
                    barcode: barcode,
                    units_per_package: this.product.units_per_package,
                    unit: this.selectedUnit,
                    unit_type: this.selectedUnit.type,
                    units: this.product.prices,
                    sale_price: Number(this.sale_price),
                    min_price: this.min_price,
                    buy_cost: Number(buy_cost),
                    stock: available_qty,
                    lastSaleCost: lastSaleCost,
                    old_qty: Number(this.qty),
                    qty: Number(this.qty),
                    inventory_id: JSON.parse(
                      localStorage.getItem("user_inventories")
                    )[0].id,
                  });
                  this.setLocalStorage();
                  this.calcTotal();
                  this.clearProduct();
                }
                this.loadingStart = true;
              })
              .catch(() => {
                this.loadingStart = true;
                loading.close();
                console.log(
                  "================ error catch for hold ==============="
                );

                this.$notify.error({
                  title: "حدث خطأ",
                  message: `عفوا المخزن المتاح لا يكفي `,
                  duration: 1500,
                });
              });
            // end hold
          }
        }
      }
      this.scrollToEnd();
    },
    addSale() {
      let damagedProducts = {
        inventory_id: this.sales[this.selectedIndex].inventory_id,
        products: []
      }
      for (let index = 0; index < this.sales[this.selectedIndex].products.length; index++) {
        let procut = {
          id: this.sales[this.selectedIndex].products[index].id,
          name: this.sales[this.selectedIndex].products[index].name,
          buy_cost: this.sales[this.selectedIndex].products[index].buy_cost,
          unit: this.sales[this.selectedIndex].products[index].unit.unit,
          sale_price: this.sales[this.selectedIndex].products[index].sale_price,
          unit_type: this.sales[this.selectedIndex].products[index].unit_type,
          units_per_package: this.sales[this.selectedIndex].products[index].units_per_package,
          stock: this.sales[this.selectedIndex].products[index].stock,
          lastPurchaseCost: this.sales[this.selectedIndex].products[index].sale_price,
          qty: this.sales[this.selectedIndex].products[index].qty
        }
        damagedProducts.products.push(procut);
      }

        if (this.sales[this.selectedIndex].products.length > 0) {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "جاري تحميل الفاتورة",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axiosApi
            .post("product-damaged", damagedProducts)
            .then((response) => {
              // this.invoice_details = response.data.invoice_details[0];
              localStorage.setItem(
                "DamagedList",
                JSON.stringify(response.data.invoice_details)
              );
              console.log(response);
              this.deleteSavedInvoiceData();
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات الفاتورة بنجاح",
                type: "success",
                duration: 1500,
              });

              this.confirmSave = false;
            })
            .catch((err) => {
              console.log(err);
              this.$notify.error({
                title: "حدث خطأ",
                message: "عفوا تأكد من بيانات الفاتورة",
                duration: 1500,
              });
            })
            .finally(() => {
              loading.close();
              this.isLoading = false;
            });
        }
    },
    calcTotal() {
      let buy_cost = 0;
      let sale_total = 0;
      this.allowSale = true;
      var qty = 0;
      for (var i = 0; i < this.sales[this.selectedIndex].products.length; i++) {
        if (
          this.sales[this.selectedIndex].products[i].buy_cost >
          this.sales[this.selectedIndex].products[i].sale_price
        ) {
          this.allowSale = false;
        }
        if (this.sales[this.selectedIndex].products[i].qty == "") {
          this.sales[this.selectedIndex].products[i].qty = 1;
        }
        let buy =
          Number(this.sales[this.selectedIndex].products[i].qty *
          this.sales[this.selectedIndex].products[i].buy_cost);

        buy_cost = buy_cost + buy;
        let sale =
          Number(this.sales[this.selectedIndex].products[i].qty *
          this.sales[this.selectedIndex].products[i].sale_price);

        sale_total = sale_total + sale;

        qty = qty + Number(this.sales[this.selectedIndex].products[i].qty);
      }
      this.checkQty();
      this.sales[this.selectedIndex].total_buy_cost = Number(buy_cost);
      this.sales[this.selectedIndex].total_sale_cost = Number(sale_total);
      this.sales[this.selectedIndex].total_qty = Number(qty);
      this.discountChange();
      this.setLocalStorage();
    },
    checkQty() {
      for (var i = 0; i < this.sales[this.selectedIndex].products.length; i++) {
        if (Number(this.sales[this.selectedIndex].products[i].qty) == 0) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }
        if (
          Number(this.sales[this.selectedIndex].products[i].qty) >
          Number(this.sales[this.selectedIndex].products[i].stock)
        ) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }

        if (this.sales[this.selectedIndex].products[i].qty == "") {
          this.sales[this.selectedIndex].products[i].qty = 1;
        }
      }
    },
    setLocalStorage() {
      localStorage.setItem("DamagedList", JSON.stringify(this.sales));
    },
    clearProduct() {
      // document.querySelector(".parcodeSearch input[type='text']").value = '';
      this.$refs.searchProductsComponent.setValue(null);
      this.qty = 1;
      this.selectedProductStock = 0;
      this.selectedProductStockLabel = "-";
      this.selectedProductlastSaleCost = "-";
      this.sale_price = "";
      this.product = null;
      this.selectedUnit = null;
      this.selectedUnitId = null;
      this.productUnits = [];
      //  this.$refs.productQuery.value = ''
      setTimeout(() => {
        if(!this.useParcode){
          document.querySelector(".productQuery input").focus();
        } else {
          document.querySelector(".parcodeSearch input[type='text']").focus();
          // document.querySelector(".parcodeSearch input[type='text']").value = '';

        }
      }, 100);
    },

    hold(item, index) {
      let productsToHold = [
        {
          id: item.id,
          qty: item.qty,
          unit_type: item.unit_type,
          inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0]
            .id,
          units_per_package: item.units_per_package,
        },
      ];

      axiosApi
        .post(`products/hold`, { products: productsToHold })
        .then((res) => {
          this.sales[this.selectedIndex].products[index].stock =
            res.data.qty / item.units_per_package;
        });
    },
    updateProductQty(item, index) {
      if (item.old_qty != item.qty && item.qty>0) {
        let productsToUnHold = [
          {
            id: item.id,
            old_qty: item.old_qty,
            qty: item.qty,
            unit_type: item.unit_type,
            inventory_id: JSON.parse(
              localStorage.getItem("user_inventories")
            )[0].id,
            units_per_package: item.units_per_package,
          },
        ];
        axiosApi
          .post(`product-change-qty`, {
            products: productsToUnHold,
          })
          .then((res) => {
            this.sales[this.selectedIndex].products[index].old_qty = item.qty;
            this.sales[this.selectedIndex].products[index].stock =
            res.data.qty / item.units_per_package;
          }).catch(()=>{
            this.sales[this.selectedIndex].products[index].qty=this.sales[this.selectedIndex].products[index].old_qty
              this.$notify({
                title: "عفوا",
                message: " الكمية غير متوفرة",
                type: "error",
                duration: 1500,
              });

          }).finally(()=>{
      this.calcTotal();

          });
      }else{
            this.sales[this.selectedIndex].products[index].qty=this.sales[this.selectedIndex].products[index].old_qty

      this.calcTotal();
      }

    },
    toggle(active) {
      this.activeSide = active;
    },

    resetInvoiceData() {
      // this.products = null;
      this.supplier = {
        id: 1,
        name: "wahtever",
        balance: 0,
      };
      axiosApi
        .post(`products/unhold`, {
          products: this.sales[this.selectedIndex].products,
        })
        .then(() => {
          if (this.sales.length > 1) {
            this.sales.splice(this.selectedIndex, 1);
            this.selectedIndex = 0;
          } else {
            this.sales[this.selectedIndex].products = [];
            // this.sales[this.selectedIndex].donne_at = this.$moment()
            //   .locale("en")
            //   .format("YYYY-MM-DD");

            this.sales[this.selectedIndex].supplier = this.supplier;

            this.sales[this.selectedIndex].total_cost = 0;
            this.sales[this.selectedIndex].paied = 0;
            this.sales[this.selectedIndex].total_buy_cost = 0;
            this.sales[this.selectedIndex].total_sale_cost = 0;
            this.sales[this.selectedIndex].total_qty = 0;
            this.sales[this.selectedIndex].total_discount = 0;
            this.sales[this.selectedIndex].percentage_discount = 0;
            this.selectedIndex = 0;
          }
          localStorage.setItem("DamagedList", JSON.stringify(this.sales));
        });
    },
    deleteSavedInvoiceData() {
      this.supplier = {
      id: 1,
      name: "wahtever",
      balance: 0,
    };
      if (this.sales.length > 1) {
        this.sales.splice(this.selectedIndex, 1);
        this.selectedIndex = 0;
      } else {
        this.sales[this.selectedIndex].products = [];
        this.sales[this.selectedIndex].supplier = this.supplier;
        this.sales[this.selectedIndex].total_cost = 0;
        this.sales[this.selectedIndex].paied = 0;
        this.sales[this.selectedIndex].total_buy_cost = 0;
        this.sales[this.selectedIndex].total_sale_cost = 0;
        this.sales[this.selectedIndex].total_qty = 0;
        this.sales[this.selectedIndex].total_discount = 0;
        this.sales[this.selectedIndex].percentage_discount = 0;
        this.selectedIndex = 0;
      }
      localStorage.setItem("DamagedList", JSON.stringify(this.sales));
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    deleteItem(product, index) {
      this.holdProduct(product, product.unit_type, product.qty * -1);
      this.sales[this.selectedIndex].products.splice(index, 1);
      this.calcTotal();
    },
    holdProduct(product, unit_type, qty) {
      let products = [];
      let selectedProduct = {
        id: product.id,
        qty: qty,
        unit_type: unit_type,
        inventory_id: 1,
        units_per_package: product.units_per_package,
      };

      products.push(selectedProduct);

      axiosApi.post(`products/hold`, { products: products }).then((res) => {
        let available_qty = res.data.qty;
        if (unit_type == 1) {
          available_qty = res.data.qty / product.units_per_package;
        }

        return available_qty;
      });
    },
    useBarcode(){
      if(this.useParcode) {
        document.querySelector(".parcodeSearch input[type='text']").focus();
      } else {
        document.querySelector(".productQuery input").focus();
      }
    },
    scrollToEnd() {
      setTimeout(() => {
        let elementToScrollDown = this.$refs.products_table;
        elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
      }, 300);
      console.log("scrollToEnd");

      // this.$el.querySelector("#goToBottom").click();
    },
  },
};
</script>

<style scoped>
#scrollToMe {
  overflow-y: scroll;
}
</style>
